import { BPProfilesAdvancedComponent } from './bp-profiles-advanced.component';
import { BPProfilesRelationsComponent } from './bp-relations/bp-profiles-relations.component';
import { BPProfilesProductCatalogComponent } from './product-catalog/bp-profiles-product-catalog.component';
import { Transition } from '@uirouter/angular';
import {
  STATE_BPPROFILES,
  STATE_BPPROFILES_ACCESS_SETTINGS,
  STATE_BPPROFILES_ACSLINFO,
  STATE_BPPROFILES_AUDIT,
  STATE_BPPROFILES_BANK,
  STATE_BPPROFILES_BP_KPI,
  STATE_BPPROFILES_CATALOG,
  STATE_BPPROFILES_CATALOG_DETAIL,
  STATE_BPPROFILES_CATALOG_OVERVIEW,
  STATE_BPPROFILES_CAVEATS,
  STATE_BPPROFILES_CHECKLISTS,
  STATE_BPPROFILES_CONTACTS,
  STATE_BPPROFILES_CONTRACT,
  STATE_BPPROFILES_DOCUMENTS,
  STATE_BPPROFILES_ENGINEER_ACCREDITATIONS,
  STATE_BPPROFILES_GENERAL,
  STATE_BPPROFILES_INVOICE,
  STATE_BPPROFILES_INVOICEDETAIL,
  STATE_BPPROFILES_INVOICEOVERVIEW,
  STATE_BPPROFILES_LBDM_CHECKLIST,
  STATE_BPPROFILES_LESSORCONFIG,
  STATE_BPPROFILES_LOCATIONS,
  STATE_BPPROFILES_MAILS,
  STATE_BPPROFILES_OEM,
  STATE_BPPROFILES_OEM_DETAIL,
  STATE_BPPROFILES_OEM_OVERVIEW,
  STATE_BPPROFILES_ORDER_KPI,
  STATE_BPPROFILES_PLATFORMCONFIG,
  STATE_BPPROFILES_PRODUCTCATALOG,
  STATE_BPPROFILES_SLA,
  STATE_BPPROFILES_INTERNAL_CONFIG,
  STATE_BPPROFILES_SURVEY,
  STATE_BPPROFILES_TC,
  STATE_BPPROFILES_TERRITORIES,
  STATE_BPPROFILES_TICKETS,
  STATE_BPPROFILES_VENDOR_ACCREDITATIONS,
  STATE_BPWIZARD_AGREEMENT,
  STATE_BPWIZARD_BANK,
  STATE_BPWIZARD_COMPANYMARGIN,
  STATE_BPWIZARD_OEM
} from '@app/shared/app-states';
import { BPProfilesViewCode } from '../bp-profiles.service';
import { BrowseListConfigService } from '@app/shared/browselists/browselists-config.service';
import { BPProfilesGeneralInfoComponent } from './general-info/bp-profiles-general-info.component';
import { BPProfilesBankComponent } from './bank/bp-profiles-bank.component';
import { WIZARD_BP_PROFILES } from '@app/shared/app-wizards';
import { BPProfilesAccessSettingsComponent } from './access-settings/bp-profiles-access-settings.component';
import { BPProfilesAcslInfoComponent } from './acsl-info/bp-profiles-acsl-info.component';
import { BPProfilesContactsComponent } from './contacts/bp-profiles-contacts.component';
import { BPProfilesOEMOverviewComponent } from './oem/bp-profiles-oem-overview.component';
import { BPProfilesOEMDetailComponent } from './oem/detail/bp-profiles-oem-detail.component';
import { BPProfilesOEMComponent } from './oem/bp-profiles-oem.component';
import { BPProfilesOEMService } from './oem/bp-profiles-oem.service';
import { BPProfilesSurveyComponent } from './survey/bp-profiles-survey.component';
import { BPProfilesDashboardComponent } from './dashboard/bp-profiles-dashboard.component';
import { BPProfilesLocationsComponent } from './locations/bp-profiles-locations.component';
import { BPProfilesAccreditationsComponent } from './accreditations/bp-profiles-accreditations.component';
import { BPProfilesDocumentsComponent } from './documents/bp-profiles-documents.component';
import { BPProfilesAuditComponent } from './audit/bp-profiles-audit.component';
import { BPProfilesCatalogComponent } from './catalog/bp-profiles-catalog.component';
import { BPProfilesCatalogOverviewComponent } from './catalog/bp-profiles-catalog-overview.component';
import { BPProfilesCatalogDetailComponent } from './catalog/detail/bp-profiles-catalog-detail.component';
import { BPProfilesTicketsComponent } from './tickets/bp-profiles-tickets.component';
import { BPProfilesInvoiceComponent } from './invoice/bp-profiles-invoice.component';
import { BPProfilesInvoiceOverviewComponent } from './invoice/bp-profiles-invoice-overview.component';
import { BPProfilesInvoiceDetailComponent } from './invoice/detail/bp-profiles-invoice-detail.component';
import { BPProfilesTerritoriesComponent } from './territories/bp-profiles-territories.component';
import { BPProfilesMailsComponent } from './mails/bp-profiles-mails.component';
import { BPProfilesTCComponent } from './tc/bp-profiles-tc.component';
import { BPProfilesContractComponent } from './contract/bp-profiles-contract.component';
import { BPProfilesCaveatsComponent } from './caveats/bp-profiles-caveats.component';
import { BPProfilesSLAComponent } from './sla/bp-profiles-sla.component';
import { BPProfilesChecklistsComponent } from './checklists/bp-profiles-checklists.component';
import { BPProfilesInternalConfigComponent } from './internal-config/bp-profiles-internal-config.component';
import { GaStateDeclaration } from '@type_definitions/datatypes';
import { ACCREDITATION_TYPE_C, ACCREDITATION_TYPE_E } from './accreditations/bp-profiles-accreditations.service';
import { TRANSLATION_READY_RESOLVER } from '@app/app-routes.config';

const PROFILE_TITLE:string = 'BPPROFILES.TITLE';

export const BP_ADVANCED_STATES:GaStateDeclaration[] = [
  {
    name: STATE_BPPROFILES,
    url: '/{profileListType:(?:mybpprofiles|otherbpprofiles|bpprofiles)}/{profileId}',
    abstract: true,
    params: {
      profileId: {
        value: '',
        raw: true
      }
    },
    component: BPProfilesAdvancedComponent,
    data: {
      viewTitle: 'My Profile(s)',
      defaultState: STATE_BPPROFILES_GENERAL
    },
    resolve: [
      { token: 'profileListType', deps: [Transition], resolveFn: (transition:Transition) => transition.params()?.profileListType },
      { token: 'profileId', deps: [Transition], resolveFn: (transition:Transition) => Number(transition.params()?.profileId) || transition.params()?.profileId },
      { token: 'hideWizardEditButton', deps: [Transition], resolveFn: (transition:Transition) => transition.to()?.data.hideWizardEditButton },
      TRANSLATION_READY_RESOLVER
    ]
  },
  {
    name: STATE_BPPROFILES_GENERAL,
    url: '',
    component: BPProfilesGeneralInfoComponent,
    data: {
      viewCode: BPProfilesViewCode.GENERAL_INFO,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.GENERAL_INFO.TEXT'
      ]
    }
  },
  {
    name: STATE_BPPROFILES_CHECKLISTS,
    url: '/profile-checklist',
    component: BPProfilesChecklistsComponent,
    data: {
      viewCode: BPProfilesViewCode.PROFILE_CHECKLISTS,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.PROFILE_CHECKLIST.TITLE'
      ],
      hideWizardEditButton: true
    }
  },
  {
    name: STATE_BPPROFILES_BANK,
    url: '/bank',
    component: BPProfilesBankComponent,
    data: {
      viewCode: BPProfilesViewCode.BANK_INFO,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.BANK.TEXT'
      ],
      wizardState: STATE_BPWIZARD_BANK
    },
    resolve: [
      { token: 'wizardId', resolveFn: () => WIZARD_BP_PROFILES },
      { token: 'showOnlinePaymentConnection', resolveFn: () => true }
    ]
  },
  {
    name: STATE_BPPROFILES_ACCESS_SETTINGS,
    url: '/access-settings',
    component: BPProfilesAccessSettingsComponent,
    data: {
      viewCode: BPProfilesViewCode.ACCESS_SETTINGS,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.ACCESS_SETTINGS.TEXT'
      ]
    }
  },
  {
    name: STATE_BPPROFILES_CONTACTS,
    url: '/contacts',
    component: BPProfilesContactsComponent,
    data: {
      viewCode: BPProfilesViewCode.CONTACTS,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.CONTACTS.TEXT'
      ],
      hideWizardEditButton: true
    }
  },
  {
    name: STATE_BPPROFILES_LOCATIONS,
    url: '/locations',
    component: BPProfilesLocationsComponent,
    data: {
      viewCode: BPProfilesViewCode.LOCATIONS,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.LOCATIONS.TEXT'
      ],
      hideWizardEditButton: true
    }
  },
  {
    name: STATE_BPPROFILES_SLA,
    url: '/sla',
    component: BPProfilesSLAComponent,
    data: {
      viewCode: BPProfilesViewCode.SLA ,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.SLA.TEXT'
      ]
    }
  },
  {
    name: STATE_BPPROFILES_TC,
    url: '/tc',
    component: BPProfilesTCComponent,
    data: {
      viewCode: BPProfilesViewCode.TC,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.TC.TEXT'
      ],
      wizardState: STATE_BPWIZARD_COMPANYMARGIN
    }
  },
  {
    name: STATE_BPPROFILES_CAVEATS,
    url: '/caveats',
    component: BPProfilesCaveatsComponent,
    data: {
      viewCode: BPProfilesViewCode.CAVEATS,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.CAVEATS.TEXT'
      ]
    }
  },
  {
    name: STATE_BPPROFILES_OEM,
    url: '/oem',
    abstract: true,
    component: BPProfilesOEMComponent
  },
  {
    name: STATE_BPPROFILES_OEM_OVERVIEW,
    url: '?filter',
    component: BPProfilesOEMOverviewComponent,
    data: {
      viewCode: BPProfilesViewCode.OEM,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.OEM.TEXT'
      ],
      noScrollTop: true,
      wizardState: STATE_BPWIZARD_OEM,
      hideWizardEditButton: true
    },
    resolve: [
      { token: 'filter', deps: [Transition], resolveFn: (transition:Transition) => transition.params()?.filter }
    ]
  },
  {
    name: STATE_BPPROFILES_OEM_DETAIL,
    url: '/{oemId}',
    component: BPProfilesOEMDetailComponent,
    data: {
      viewCode: BPProfilesViewCode.OEM,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.OEM.TEXT'
      ]
    },
    resolve: [
      { token: 'oemId', deps: [Transition, BPProfilesOEMService], resolveFn: (transition:Transition, bpProfilesOEMService:BPProfilesOEMService) => bpProfilesOEMService.fromStateParam(transition.params()?.oemId)?.oemId },
      { token: 'distributorId', deps: [Transition, BPProfilesOEMService], resolveFn: (transition:Transition, bpProfilesOEMService:BPProfilesOEMService) => bpProfilesOEMService.fromStateParam(transition.params()?.oemId)?.distributorId }
    ]
  },
  {
    name: STATE_BPPROFILES_VENDOR_ACCREDITATIONS,
    url: '/accreditations',
    component: BPProfilesAccreditationsComponent,
    data: {
      viewCode: BPProfilesViewCode.ACCREDITATIONS,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.ACCREDITATIONS.TEXT'
      ],
      hideWizardEditButton: true
    },
    resolve: [
      { token: 'accreditationType', resolveFn: () => ACCREDITATION_TYPE_C }
    ]
  },
  {
    name: STATE_BPPROFILES_ENGINEER_ACCREDITATIONS,
    url: '/engineer-accreditations',
    component: BPProfilesAccreditationsComponent,
    data: {
      viewCode: BPProfilesViewCode.ACCREDITATIONS,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.ENGINEER_ACCREDITATIONS.TEXT'
      ],
      hideWizardEditButton: true
    },
    resolve: [
      { token: 'accreditationType', resolveFn: () => ACCREDITATION_TYPE_E }
    ]
  },
  {
    name: STATE_BPPROFILES_PRODUCTCATALOG,
    url: '/product-catalog',
    component: BPProfilesProductCatalogComponent,
    data: {
      viewCode: BPProfilesViewCode.PRODUCT_CATALOG,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.PRODUCT_CATALOG.TEXT'
      ],
      hideWizardEditButton: true
    }
  },
  {
    name: STATE_BPPROFILES_CATALOG,
    url: '/catalog',
    component: BPProfilesCatalogComponent,
    abstract: true
  },
  {
    name: STATE_BPPROFILES_CATALOG_OVERVIEW,
    url: '?category',
    component: BPProfilesCatalogOverviewComponent,
    data: {
      viewCode: BPProfilesViewCode.CATALOG,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.CATALOG.TEXT'
      ],
      hideWizardEditButton: true
    },
    params: {
      category: { dynamic: true, type: 'string' }
    },
    resolve: [
      { token: 'selectedCategory', deps: [Transition], resolveFn: (transition:Transition) => transition.params()?.category }
    ]
  },
  {
    name: STATE_BPPROFILES_CATALOG_DETAIL,
    url: '/{catalogItemId}',
    component: BPProfilesCatalogDetailComponent,
    data: {
      viewCode: BPProfilesViewCode.CATALOG,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.CATALOG.TEXT'
      ]
    },
    resolve: [
      { token: 'catalogItemId', deps: [Transition], resolveFn: (transition:Transition) => transition.params()?.catalogItemId }
    ]
  },
  {
    name: STATE_BPPROFILES_DOCUMENTS,
    url: '/documents',
    component: BPProfilesDocumentsComponent,
    data: {
      viewCode: BPProfilesViewCode.DOCUMENTS,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.DOCUMENTS.TEXT'
      ],
      hideWizardEditButton: true
    }
  },
  {
    name: STATE_BPPROFILES_INTERNAL_CONFIG,
    url: '/internalconfig',
    component: BPProfilesInternalConfigComponent,
    data: {
      viewCode: BPProfilesViewCode.INTERNAL_CONFIG,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.INTERNAL_CONFIG.TEXT'
      ],
      hideWizardEditButton: true
    }
  },
  {
    name: STATE_BPPROFILES_LESSORCONFIG,
    url: '/lessorconfig',
    component: BPProfilesRelationsComponent,
    data: {
      viewCode: BPProfilesViewCode.LESSOR_CONFIG,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.LESSOR_CONFIG.TEXT'
      ],
      hideWizardEditButton: true
    },
    resolve: [
      { token: 'ownerType', resolveFn: () => 'L' },
      { token: 'title', resolveFn: () => 'Lessor Config' },
      { token: 'browselistConfig', deps: [BrowseListConfigService], resolveFn: (browselistConfigService: BrowseListConfigService) => browselistConfigService.getConfig('BP_RELATIONS') }
    ]
  },
  {
    name: STATE_BPPROFILES_PLATFORMCONFIG,
    url: '/platformconfig',
    component: BPProfilesRelationsComponent,
    data: {
      viewCode: BPProfilesViewCode.PLATFORM_CONFIG,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.PLATFORM_CONFIG.TEXT'
      ],
      hideWizardEditButton: true
    },
    resolve: [
      { token: 'ownerType', resolveFn: () => 'T' },
      { token: 'title', resolveFn: () => 'Platform Config' },
      { token: 'browselistConfig', deps: [BrowseListConfigService], resolveFn: (browselistConfigService: BrowseListConfigService) => browselistConfigService.getConfig('BP_RELATIONS') }
    ]
  },
  {
    name: STATE_BPPROFILES_ACSLINFO,
    url: '/acsl-info',
    component: BPProfilesAcslInfoComponent,
    data: {
      viewCode: BPProfilesViewCode.ACSL_INFO,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.ACSL_INFO.ACSLINFO.TITLE'
      ]
    }
  },
  {
    name: STATE_BPPROFILES_MAILS,
    url: '/mails',
    component: BPProfilesMailsComponent,
    data: {
      viewCode: BPProfilesViewCode.MAILS,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.MAILS.TITLE'
      ],
      hideWizardEditButton: true
    }
  },
  {
    name: STATE_BPPROFILES_TICKETS,
    url: '/tickets',
    component: BPProfilesTicketsComponent,
    data: {
      viewCode: BPProfilesViewCode.TICKETS,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.TICKETS.TITLE'
      ],
      hideWizardEditButton: true
    }
  },
  {
    name: STATE_BPPROFILES_CONTRACT,
    url: '/contract',
    component: BPProfilesContractComponent,
    data: {
      viewCode: BPProfilesViewCode.CONTRACT,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.CONTRACT.TITLE'
      ],
      wizardState: STATE_BPWIZARD_AGREEMENT
    }
  },
  {
    name: STATE_BPPROFILES_TERRITORIES,
    url: '/territories',
    component: BPProfilesTerritoriesComponent,
    data: {
      viewCode: BPProfilesViewCode.TERRITORIES,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.TERRITORIES.TITLE'
      ]
    }
  },
  {
    name: STATE_BPPROFILES_INVOICE,
    url: '/invoice',
    abstract: true,
    component: BPProfilesInvoiceComponent
  },
  {
    name: STATE_BPPROFILES_INVOICEOVERVIEW,
    url: '',
    component: BPProfilesInvoiceOverviewComponent,
    data: {
      viewCode: BPProfilesViewCode.INVOICE,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.INVOICE.TITLE'
      ],
      hideWizardEditButton: true
    }
  },
  {
    name: STATE_BPPROFILES_INVOICEDETAIL,
    url: '/{invoiceTemplateId}',
    component: BPProfilesInvoiceDetailComponent,
    data: {
      viewCode: BPProfilesViewCode.INVOICE,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.INVOICE.TITLE'
      ]
    },
    resolve: [
      { token: 'invoiceTemplateId', deps: [Transition], resolveFn: (transition:Transition) => transition.params()?.invoiceTemplateId }
    ]
  },
  {
    name: STATE_BPPROFILES_SURVEY,
    url: '/survey',
    component: BPProfilesSurveyComponent,
    data: {
      viewCode: BPProfilesViewCode.SURVEY,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.SURVEY.TITLE'
      ],
      hideWizardEditButton: true
    }
  },
  {
    name: STATE_BPPROFILES_AUDIT,
    url: '/audit',
    component: BPProfilesAuditComponent,
    data: {
      viewCode: BPProfilesViewCode.AUDIT,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.AUDIT.TEXT'
      ],
      hideWizardEditButton: true
    }
  },
  {
    name: STATE_BPPROFILES_LBDM_CHECKLIST,
    url: '/lbdm-checklist',
    component: BPProfilesDashboardComponent,
    data: {
      viewCode: BPProfilesViewCode.LBDM_CHECKLIST,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.LBDM_CHECKLIST.TEXT'
      ],
      hideWizardEditButton: true
    },
    resolve: [
      { token: 'dashboardCode', resolveFn: ():string => 'LBDM' }
    ]
  },
  {
    name: STATE_BPPROFILES_ORDER_KPI,
    url: '/orderkpi',
    component: BPProfilesDashboardComponent,
    data: {
      viewCode: BPProfilesViewCode.ORDER_KPI,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.ORDER_KPI.TEXT'
      ],
      hideWizardEditButton: true
    },
    resolve: [
      { token: 'dashboardCode', resolveFn: ():string => 'OD_ORDER' }
    ]
  },
  {
    name: STATE_BPPROFILES_BP_KPI,
    url: '/bpkpi',
    component: BPProfilesDashboardComponent,
    data: {
      viewCode: BPProfilesViewCode.BP_KPI,
      viewTitle: [
        PROFILE_TITLE,
        'BPPROFILES.BP_KPI.TEXT'
      ],
      hideWizardEditButton: true
    },
    resolve: [
      { token: 'dashboardCode', resolveFn: ():string => 'OD_BP' }
    ]
  }
];